<ion-card *ngIf="generalBanners && generalBanners.length > 0">
    <img *ngIf="generalBanners[currentBannerIndex].multimediaType !== 'MP4'" [src]="generalBanners[currentBannerIndex].url" [class]="fadeInOutClass">
    <video *ngIf="generalBanners[currentBannerIndex].multimediaType === 'MP4'" [class]="fadeInOutClass">
        <source [src]="generalBanners[currentBannerIndex].url" type="video/mp4">
    </video>
</ion-card>